export default __webpack_public_path__ + "static/media/authoring_empty_state.aabf7bab.svg";